(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c_announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class CedarwoodAnnouncement extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('.c_js-ann-slide'));
      this.index = 0;
      this.timer = null;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      const autoplay = this.getAttribute('data-autoplay') === 'true';
      if (autoplay && this.slides.length > 1 && !this.reduceMotion) {
        this.start();
        this.addEventListener('mouseenter', this.stop.bind(this));
        this.addEventListener('mouseleave', this.start.bind(this));
        this.addEventListener('focusin', this.stop.bind(this));
        this.addEventListener('focusout', this.start.bind(this));
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      var sec = parseFloat(this.getAttribute('data-interval')) || 5;
      this.timer = setInterval(this.next.bind(this), sec * 1000);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      this.slides[this.index].classList.remove('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'true');
      this.index = (this.index + 1) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
      this.slides[this.index].removeAttribute('aria-hidden');
    }
  }

  if (!customElements.get('cedarwood-announcement')) {
    customElements.define('cedarwood-announcement', CedarwoodAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_header"] && !Shopify.designMode) return;
  try {
    
  class CedarwoodHeader extends HTMLElement {
    constructor() {
      super();
      this.backdrop = this.querySelector('.c_js-header-backdrop');
      this.menuDrawer = this.querySelector('.c_js-header-drawer');
      this.menuToggle = this.querySelector('.c_js-header-menu-toggle');
      this.menuClose = this.querySelector('.c_js-header-menu-close');
      this.searchDrawer = this.querySelector('.c_js-header-search-drawer');
      this.searchToggle = this.querySelector('.c_js-header-search-toggle');
      this.searchClose = this.querySelector('.c_js-header-search-close');
      this.searchInput = this.searchDrawer && this.searchDrawer.querySelector('input[type="search"]');
      this.activeDrawer = null;
      this.activeToggle = null;
      this.openMenu = this.openMenu.bind(this);
      this.toggleSearch = this.toggleSearch.bind(this);
      this.close = this.close.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.updateScrollState = this.updateScrollState.bind(this);
      this.sticky = this.getAttribute('data-sticky') === 'true';
      this.scrollTicking = false;
    }

    connectedCallback() {
      if (this.menuToggle) this.menuToggle.addEventListener('click', this.openMenu);
      if (this.menuClose) this.menuClose.addEventListener('click', this.close);
      if (this.searchToggle) this.searchToggle.addEventListener('click', this.toggleSearch);
      if (this.searchClose) this.searchClose.addEventListener('click', this.close);
      if (this.backdrop) this.backdrop.addEventListener('click', this.close);

      if (this.searchDrawer && this.searchDrawer.querySelector('predictive-search')) {
        this.fixPredictiveSearchLocale();
      }

      this.isOverlay = this.dataset.overlay === 'true';

      // 告知バー高さ（--announcement-h）はホットパスで毎フレーム読まず、connect時に一度だけ取得
      this.announcementH =
        parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--announcement-h')) || 0;
      this.stickyTop = null;
      // sticky 無効でも初期値は公開する。商品ページの sticky カラムが参照するため（#161）
      this.setStickyTop(this.isOverlay ? this.announcementH : 0);

      // overlay は sticky 無効でもスクロール監視が要る。告知バーが流れる分を --sticky-top に
      // 追従させないと、商品ページの sticky カラムが消えたヘッダー分の余白を持ち続ける（#161）
      if (this.sticky || this.isOverlay) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateScrollState();
      }

      if (this.isOverlay) this.setupHeaderTone();
    }

    // マーカー [data-overlay-hero] は index・商品が持つが、tone 切替は index 限定。
    // 商品ページは data-overlay-tone=false で早期 return し、既定色のまま重ねる
    setupHeaderTone() {
      if (this.dataset.overlayTone !== 'true') return;

      const main = document.getElementById('MainContent');
      const first = main && main.querySelector(':scope > .shopify-section');
      const hero = first && first.querySelector('[data-overlay-hero]');
      if (!hero) return;

      const headerH = this.offsetHeight || 64;
      const apply = (over) => {
        if (over) {
          this.setAttribute('data-tone', 'over-hero');
        } else {
          this.removeAttribute('data-tone');
        }
      };

      // IntersectionObserver は非同期のため、初期状態を同期評価してフラッシュを防ぐ
      apply(hero.getBoundingClientRect().bottom > headerH);

      // ルート上端を headerH 分だけ縮め、hero が「ヘッダー帯より下」に在る間だけ intersecting=true
      this.toneObserver = new IntersectionObserver(
        (entries) => {
          apply(entries[0].isIntersecting);
        },
        { rootMargin: `-${headerH}px 0px 0px 0px`, threshold: 0 },
      );
      this.toneObserver.observe(hero);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.toneObserver) this.toneObserver.disconnect();
      // :root に書いた値は要素と一緒に消えないため明示的に戻す（#161）
      document.documentElement.style.removeProperty('--sticky-top');
    }

    // 商品ページの sticky カラムがヘッダー下端に追従するために参照する（#161）。
    // 値が変化した時だけ書き込み、0 に達した後の毎フレーム書き込みを抑制する
    setStickyTop(top) {
      if (top === this.stickyTop) return;
      this.stickyTop = top;
      document.documentElement.style.setProperty('--sticky-top', top + 'px');
    }

    // スクロールイベントは rAF で1フレーム1回に集約（毎イベントの読み取り/書き込みを抑制）
    onScroll() {
      if (this.scrollTicking) return;
      this.scrollTicking = true;
      requestAnimationFrame(this.updateScrollState);
    }

    updateScrollState() {
      this.scrollTicking = false;
      const y = window.scrollY;
      this.classList.toggle('is-scrolled', y > 4);

      // オーバーレイ併用の固定ヘッダーは、告知バーが流れる分だけ上端を 0 まで詰める。
      // 非オーバーレイは top:0 にピン留めされるため常に 0。
      this.setStickyTop(this.isOverlay ? Math.max(0, this.announcementH - y) : 0);
    }

    // 接頭辞なしの /search/suggest は buyer locale を解決できず HTTP 417 になるため、
    // root が '/' のときだけ現在ロケールを前置する（ロケール付きなら Dawn 既定を尊重）
    fixPredictiveSearchLocale() {
      const shopify = window.Shopify;
      if (!shopify || !shopify.locale || !window.routes || !window.routes.predictive_search_url) return;
      const root = (shopify.routes && shopify.routes.root) || '/';
      if (root !== '/') return;
      const prefix = '/' + shopify.locale;
      if (window.routes.predictive_search_url.indexOf(prefix + '/') === 0) return;
      window.routes.predictive_search_url = prefix + window.routes.predictive_search_url;
    }

    openMenu() {
      this.openDrawer(this.menuDrawer, this.menuToggle, this.menuClose);
    }

    // a[href] を土台にしているため、JS 拡張時は既定遷移を抑止する
    toggleSearch(event) {
      if (event) event.preventDefault();
      if (this.activeDrawer === this.searchDrawer) {
        this.close();
      } else {
        this.openDrawer(this.searchDrawer, this.searchToggle, this.searchInput);
      }
    }

    openDrawer(drawer, toggle, focusEl) {
      if (!drawer) return;
      // 片方が開いていれば先に閉じる（backdrop の二重管理を避ける）
      if (this.activeDrawer) this.close();
      drawer.hidden = false;
      if (this.backdrop) this.backdrop.hidden = false;
      this.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', this.onKeydown);
      this.activeDrawer = drawer;
      this.activeToggle = toggle;
      if (focusEl) focusEl.focus();
    }

    close() {
      if (!this.activeDrawer) return;
      this.classList.remove('is-open');
      if (this.activeToggle) this.activeToggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this.onKeydown);
      this.activeDrawer.hidden = true;
      if (this.backdrop) this.backdrop.hidden = true;
      const toggle = this.activeToggle;
      this.activeDrawer = null;
      this.activeToggle = null;
      if (toggle) toggle.focus();
    }

    onKeydown(event) {
      // Escape が二重に効いてドロワーごと閉じ、Tab の巡回先が inert になるため dialog に委ねる
      if (document.querySelector('dialog[data-fc-dialog]:modal')) return;
      if (event.key === 'Escape') {
        this.close();
        return;
      }
      // aria-modal ドロワー内に Tab を閉じ込める（背後のリンクへフォーカスが抜けるのを防ぐ）
      if (event.key !== 'Tab' || !this.activeDrawer) return;
      const selector =
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      const focusable = Array.prototype.filter.call(this.activeDrawer.querySelectorAll(selector), function (el) {
        return el.offsetParent !== null;
      });
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('cedarwood-header')) {
    customElements.define('cedarwood-header', CedarwoodHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_history-products"] && !Shopify.designMode) return;
  try {
    
  class CedarwoodHistory extends HTMLElement {
    connectedCallback() {
      const KEY = 'cw_recently_viewed';
      const current = this.dataset.currentHandle;
      const limit = parseInt(this.dataset.limit, 10) || 12;
      const storageLimit = parseInt(this.dataset.storageLimit, 10) || 20;

      let history = [];
      try {
        const parsed = JSON.parse(localStorage.getItem(KEY));
        history = Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        history = [];
      }

      if (current) {
        history = history.filter((h) => h !== current);
        history.unshift(current);
        history = history.slice(0, storageLimit);
        try {
          localStorage.setItem(KEY, JSON.stringify(history));
        } catch (e) {}
      }

      const track = this.querySelector('[data-history-track]');
      if (!track) return;

      const byHandle = {};
      this.querySelectorAll('[data-history-item]').forEach((li) => {
        byHandle[li.dataset.handle] = li;
      });

      let shown = 0;
      history.forEach((handle) => {
        if (handle === current || shown >= limit) return;
        const li = byHandle[handle];
        if (li) {
          li.hidden = false;
          track.appendChild(li);
          shown += 1;
        }
      });

      if (shown > 0) {
        this.hidden = false;
      }
    }
  }

  if (!customElements.get('cedarwood-history')) {
    customElements.define('cedarwood-history', CedarwoodHistory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_index-hero-pattern-1"] && !Shopify.designMode) return;
  try {
    
  // 表示中のビューポートの動画だけを読み込み・再生し、二重ダウンロードを避ける
  document.querySelectorAll('.c_p-index-hero-pattern-1__media[data-responsive-video]').forEach(function (media) {
    var desktop = media.querySelector('.c_p-index-hero-pattern-1__video--desktop');
    var mobile = media.querySelector('.c_p-index-hero-pattern-1__video--mobile');
    if (!desktop || !mobile) return;

    var mq = window.matchMedia('(max-width: 768px)');
    var current = null;

    function activate() {
      var next = mq.matches ? mobile : desktop;
      if (next === current) return;
      if (current) current.pause();
      current = next;
      if (current.preload !== 'auto') current.preload = 'auto';
      if (current.networkState === 0 || current.readyState === 0) current.load();
      var p = current.play();
      if (p && p.catch) p.catch(function () {});
    }

    activate();
    if (mq.addEventListener) mq.addEventListener('change', activate);
    else if (mq.addListener) mq.addListener(activate);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
